import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import AssignmentUnitsResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentUnits.resource";
import { resetCreateResult } from "./actions.js";
import { prefix } from "./constants.js";
import { appendAssignmentUnit } from "../../common/epics/actions.js";
const createAssignmentUnitEpicReducerArgs = {
  actionPrefix: `${prefix}/CREATEV2`,
  reduxKeyNested: () => ["createResult"],
  loadResource: (inputPayload) => AssignmentUnitsResource.createAssignmentUnit(inputPayload.workspaceId, inputPayload.assignmentUnit),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    appendAssignmentUnit(outputPayload),
    resetCreateResult()
  ]
};
const createAssignmentUnitEpicReducer = loadResourcesUtils(createAssignmentUnitEpicReducerArgs);
export {
  createAssignmentUnitEpicReducer
};
//# sourceMappingURL=epicsV2.js.map
